import pool17 from "../abis/production/pools/17";
import pool12 from "../abis/production/pools/12";
import pool8 from "../abis/production/pools/8";

const host = "https://bscscan.com/address";

export default [
  {
    title: "17°C Cold Pool",
    contractAddress: "0xd999691a30e23e36b53c9c97e96b1f4b4579eb78",
    minApr: 159,
    abi: pool17.abi,
    url: `${host}/0xd999691a30e23e36b53c9c97e96b1f4b4579eb78`,
  },
  {
    title: "12°C Cold Pool",
    contractAddress: "0x943c4c9560384b068656ff56347e9334c753da93",
    minApr: 175,
    abi: pool12.abi,
    url: `${host}/0x943c4c9560384b068656ff56347e9334c753da93`,
  },
  {
    title: "8°C Cold Pool",
    contractAddress: "0x1047bbdc76bc5f19c9205e4defc682ccd1500cde",
    abi: pool8.abi,
    minApr: 200,
    url: `${host}/0x1047bbdc76bc5f19c9205e4defc682ccd1500cde`,
  },
];
